import React from 'react';
import { HeaderIcon, IconCart } from '@banhala/ui-kit';
import { bridge, useNavigator } from 'shared/src/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getCartMeta } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';

interface CartIconProps {
  screen: string;
}

interface CartIconInternalProps {
  onPress: () => void;
}

export const CartIcon: React.FC<CartIconProps> = ({ screen }) => {
  const { navigator } = useNavigator();
  return (
    <React.Suspense
      fallback={
        <HeaderIcon
          onPress={() => {
            handlePressIconCart(screen, navigator);
          }}
        >
          <IconCart />
        </HeaderIcon>
      }
    >
      <CartIconInternal
        onPress={() => {
          handlePressIconCart(screen, navigator);
        }}
      />
    </React.Suspense>
  );
};

const logClickCart = (screen: string) => {
  bridge.logAnalyticsEvent({
    channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
    name: 'CLICK_CART',
    analytics: {
      SCREEN: screen,
      LANDING_FROM: 'CARTICON',
    },
  });
};

const handlePressIconCart = (
  screen: string,
  navigator: ReturnType<typeof useNavigator>['navigator'],
) => {
  logClickCart(screen);
  navigator.moveToWebview('Cart');
};

const CartIconInternal = ({ onPress }: CartIconInternalProps) => {
  const { data: cartsCount } = useSuspenseQuery({
    queryKey: queryKey.cartMeta,
    queryFn: getCartMeta,
    select: data => data.data.carts_count,
  });
  return (
    <HeaderIcon onPress={onPress} badgeNum={cartsCount ?? 0}>
      <IconCart />
    </HeaderIcon>
  );
};
